import React, { useEffect, useState } from 'react'
import * as styled from '../../../style/main.style'
import { useTranslation } from 'react-i18next'
import { Button, MenuItem, Typography, ListItemText, Box } from '@mui/material'
import { ButtonOutlined } from '../../../../../component/mui-custom/MuiCustom'
import { RouteImage } from '../../../../../assets/routeImage'
import { colors } from '../../../../../constants/colors'

// COMPONENT
import Header from '../../../Header'
import Navbar from '../../../Navbar'
import HeaderTopicTable from '../../../../../component/header-table/HeaderTopicTable'
import FilterSelect from '../../../../../component/select/filterSelect'
import TableRowCommon from '../../../../../component/table/TableRowCommon'
import TableCustom from '../../../../../component/table/tableCustom'
import ModalCustom from '../../../../../component/modal/ModalCustom'
import AddPermission from './add-permission/AddPermission'


// API
import { PositionsApi, positionTableType, updatePositionType } from '../../../../../api/positions/positions.api';

// STORE
import { useDispatch, useSelector } from 'react-redux'
import { setLoading, unsetLoading } from '../../../../../store/slice/loading/loading.slice'
import Loading from '../../../../../component/loading/Loading'

const PermissionDetail: React.FC = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const isLoading = useSelector((state: any) => state.loading?.isLoading);

    const [positions, setPositions] = useState<any[]>([])
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(5);
    const [keyword, setKeyword] = useState<string>("");
    const [totalItems, setTotalItems] = useState<number>(Number);
    const [showModal, setShowModal] = useState<boolean>(false)

    const handleToggleModal = () => setShowModal(!showModal)

    const handleGetPositions = async () => {
        dispatch(setLoading())
        let condition: positionTableType = {}
        if (page) condition = { ...condition, page: page }
        if (pageLimit) condition = { ...condition, limit: pageLimit }
        if (keyword) condition = { ...condition, keyword: keyword }
        await PositionsApi.getPosition(condition)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    setPositions(res.data?.result?.items)
                    setTotalItems(res.data?.result?.meta?.totalItems)
                    console.log(res.data)
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error)
            })
    }
    const handleChangeStatusPosition = async (positionId: number, status: string, positionName: string) => {
        dispatch(setLoading())
        let condition: updatePositionType = {
            positionName: positionName,
            status: status
        }
        await PositionsApi.updatePosition(positionId, condition)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error)
            })
            .finally(() => handleGetPositions())
    }


    const headCells = [
        {
            id: "OFFICER", disablePadding: false, align: 'left', label:
                <HeaderTopicTable align='start' minWidth='453px' text='เจ้าหน้าที่ผู้รับผิดชอบนำเข้าระบบ' />
        },
        {
            id: "AGENCY", disablePadding: true, align: 'center', label:
                <HeaderTopicTable align='center' minWidth='657px' text='หน่วยงาน' />
        },
        {
            id: "STATUS", disablePadding: true, align: 'center', label:
                <HeaderTopicTable align='center' text='สถานะ' />
        },
        {
            id: "EDIT", disablePadding: false, align: "left", label: ""
        }
    ];

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const { idPosition, positionName, status } =
            objData;

        const objRenderData = {
            key: idPosition,
            id: no,
            obj: objData,
            columns: [
                {
                    option: "TEXT",
                    align: "left", label: positionName,
                    style: {
                        backgroundColor: colors.lampang_bg_input_secondary
                    }
                },
                {
                    option: "TEXT",
                    align: "center", label: "-",
                    style: {
                        backgroundColor: colors.lampang_bg_input_secondary
                    }
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    component:
                        <div className='max-w-[153px]'>
                            <FilterSelect
                                headingNormal
                                renderValue={() =>
                                    <ListItemText className='relative hover:bg-sub_primary'>
                                        {status === t("STATUS.ACTIVE") ? (
                                            <Typography
                                                className='text-light_success after:left-[-0.5rem] after:translate-y-[-50%] after:top-1/2 after:absolute after:w-[6px] after:h-[6px] after:bg-light_success after:rounded-[50%]'>
                                                {status}
                                            </Typography>
                                        ) : (
                                            <Typography
                                                className='text-danger after:left-[-0.5rem] after:translate-y-[-50%] after:top-1/2 after:absolute after:w-[6px] after:h-[6px] after:bg-danger after:rounded-[50%]'>
                                                {status}
                                            </Typography>
                                        )}
                                    </ListItemText>
                                }
                                label={t('STATUS.LABEL')}
                                selectId="select-fiscal-year"
                                value={status}
                                labelId="label-fiscal-year"
                                onchange={(e: React.ChangeEvent<HTMLSelectElement>) => handleChangeStatusPosition(idPosition, e.target.value, positionName)}
                                options={[
                                    <MenuItem key="1" value={t("STATUS.ACTIVE")}>
                                        <li><Typography className='text-light_success'>{t("STATUS.ACTIVE")}</Typography></li>
                                    </MenuItem>,
                                    <MenuItem key="2" value={t("STATUS.INACTIVE")}>
                                        <li><Typography className='text-danger'>{t("STATUS.INACTIVE")}</Typography></li>
                                    </MenuItem>
                                ]}
                            />
                        </div>,
                    style: {
                        backgroundColor: colors.lampang_bg_input_secondary
                    }
                },
                {
                    option: "COMPONENT",
                    align: "right",
                    style: {
                        backgroundColor: colors.lampang_bg_input_secondary
                    },
                    width: 10,
                    component:
                        <Button onClick={handleToggleModal} className='cursor-pointer w-[24px]'>
                            <img src={RouteImage.editPen} width={24} alt="icons" />
                        </Button>
                }
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };

    useEffect(() => {
        handleGetPositions();
    }, [])

    return (
        <styled.ContainerHome>
            {showModal && (
                <ModalCustom
                    enableExit={handleToggleModal}
                    maxHeight='auto'
                    alignHeader='center'
                    heading='เจ้าหน้าที่ผู้รับผิดชอบนำเข้าระบบ'
                    component={<AddPermission />}
                />
            )}
            <Navbar />
            {isLoading === true && <Loading />}
            <styled.MainContainer>
                <Header />
                <styled.Content
                    initial={{ x: 100 }}
                    animate={{ x: 0 }}
                    transition={{ ease: "backInOut", stiffness: 50 }}
                >
                    <styled.TopicHeader>
                        <div>
                            <Typography className='text-primary' variant='h4'>
                                เจ้าหน้าที่ผู้ดูแลระบบ
                            </Typography>
                        </div>
                        <span>
                            <ButtonOutlined
                                onClick={handleToggleModal}
                                startIcon={<img src={RouteImage.addButton} />}>
                                <Typography className='text-primary'> {t("BUTTON.ADD")}</Typography>
                            </ButtonOutlined>
                        </span>
                    </styled.TopicHeader>
                    <section className='mt-8 w-full h-auto'>
                        {positions && (
                            <TableCustom
                                customScroll
                                page={page}
                                pageLimit={pageLimit}
                                sortBy=""
                                sortType="ASC"
                                headCells={headCells}
                                rowCount={totalItems}
                                rowsData={positions.map((data: any, i: any) => {
                                    return renderData(data, i)
                                })}
                                onSort={() => { }}
                                setPageLimit={(value: number) => setPageLimit(value)}
                                setPage={(value: number) => setPage(value)}
                            />
                        )}
                    </section>
                </styled.Content>
            </styled.MainContainer>

        </styled.ContainerHome>
    )
}

export default PermissionDetail
